import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IStatTileTitleProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useStatTileContext
} from "../../context";
import Text from "../../../text";

const StatTileTitle: FC<IStatTileTitleProps> = ({
    customTheme: customThemeProp,
    icon: Icon,
    children,
    style,
    ...props
}) => {
    const context = useStatTileContext({
        part: "title"
    });

    const customTheme = customThemeProp ?? context?.customTheme;

    const {
        iconSizes,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    if(!context) {
        return null;
    }

    return <View
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {
            Icon ?
                <View
                    aria-hidden={true}
                >
                    <Icon
                        customColor={colors.content.icon.mid}
                        size={iconSizes.small}
                        color="mid"
                    />
                </View>
            :
                null
        }
        <Text
            {...props}
            customTheme={customTheme}
            variant="labelMediumSize"
            style={[
                style,
                stylesheet.text
            ]}
            numberOfLines={1}
            color="mid"
        >
            {children}
        </Text>
    </View>;
};
export default StatTileTitle;
